var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputNumber',{staticStyle:{"width":"100%"},attrs:{"min":0},on:{"on-change":_vm.change},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-563f70c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/duration.vue
// module id = null
// module chunks = 